// TECH DEBT: To be moved into seperate child component files per game.
// Hamster race specific child components to be moved into hamster race implmentations folder and merge the default and game specific files in the game view.

import CallValueComponent from '@/components/game/implementations/_default/_components/call-value';
import WinnerListComponent from '@/components/game/implementations/_default/_components/winner-list';
import HamsterRaceWinnerListComponent from '@/components/game/implementations/uk/hamster-race/_components/winner-list';
import PrizeComponent from '@/components/game/implementations/_default/_components/prize';
import Bingo75PrizeComponent from '@/components/game/implementations/uk/bingo-75/_components/prize';
import PotionPrizeComponent from '@/components/game/implementations/uk/potion/_components/prize';
import HamsterRacePrizeComponent from '@/components/game/implementations/uk/hamster-race/_components/prize';
import CallboardComponent from '@/components/game/implementations/_default/_components/callboard';
import CallCounterComponent from '@/components/game/implementations/_default/_components/call-counter';
import HamsterRaceCallValueComponent from '@/components/game/implementations/uk/hamster-race/_components/call-value';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';
import NextGameComponent from '@/components/game/implementations/_default/_components/next-game';
import PlayerCountComponent from '@/components/game/implementations/_default/_components/player-count';
import NextPatternComponent from '@/components/game/implementations/uk/bingo-75/_components/pattern/next-pattern';
import CurrentPatternComponent from '@/components/game/implementations/uk/bingo-75/_components/pattern/current-pattern';
import HamsterRaceLastEightWinnersComponent from '@/components/game/implementations/uk/hamster-race/_components/game-info/last-eight-winners';
import HamsterRaceLastOneHundredRaceResultsComponent from '@/components/game/implementations/uk/hamster-race/_components/game-info/last-one-hundred-race-results';
import RollerCoasterLastSixCallsComponent from '@/components/game/implementations/uk/roller-coaster/_components/last-six-calls';
import BoxNumberCallboardComponent from '@/components/game/implementations/_default/_components/box-number-callboard';

const gameChildComponents = {
  callboard: CallboardComponent,
  callCounter: CallCounterComponent,
  callValue: CallValueComponent,
  hamsterRaceCallValue: HamsterRaceCallValueComponent,
  jackpot: JackpotComponent,
  nextGame: NextGameComponent,
  playerCount: PlayerCountComponent,
  winnerList: WinnerListComponent,
  hamsterRaceWinnerList: HamsterRaceWinnerListComponent,
  prize: PrizeComponent,
  hamsterRacePrize: HamsterRacePrizeComponent,
  nextPattern: NextPatternComponent,
  currentPattern: CurrentPatternComponent,
  bingo75Prize: Bingo75PrizeComponent,
  potionPrize: PotionPrizeComponent,
  hamsterRaceLastEightWinners: HamsterRaceLastEightWinnersComponent,
  hamsterRaceLastOneHundredRaceResults: HamsterRaceLastOneHundredRaceResultsComponent,
  rollerCoasterLastSixCalls: RollerCoasterLastSixCallsComponent,
  boxnumberCallboard: BoxNumberCallboardComponent
};
export default gameChildComponents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/index.ts